import React, { useEffect, useState } from "react";
import { PiPlusCircleBold } from "react-icons/pi";
import { publicImageProps } from "../../../../../../../../services/config";
import DefaultImage from "../../../../../../../../components/common/default-image/DefaultImage";
import { digitsThree } from "../../../../../../../../utils/price";

function SearchProductCard({ data, addProduct }) {
  const [checkProductStock, setCheckProductStock] = useState(true);

  useEffect(() => {
    setCheckProductStock(data?.checkStock && data?.stock == 0 ? false : true);
  }, [data]);

  return (
    <div className="w-full border-b border-gray-200 bg-white p-4">
      <div className="space-y-4 flex items-center flex-col md:flex-row md:gap-6 md:space-y-0">
        <div className="w-10 h-10 flex items-center justify-center bg-green-300 rounded-xl overflow-hidden">
          {data?.mainImage ? (
            <img
              {...publicImageProps(data?.mainImage)}
              className="w-full h-full"
            />
          ) : (
            <DefaultImage imgClass={"!w-full !h-full"} />
          )}
        </div>
        <div className="w-full flex flex-col md:flex-row gap-2 items-center justify-between">
          <div>
            <div className="text-base text-center md:text-right font-medium text-gray-900 hover:underline dark:text-white">
              {data?.name}
            </div>
          </div>
          <div className="flex items-center gap-6 w-auto">
            <p className="text-sm font-bold text-gray-900 dark:text-white text-center">
              {digitsThree(data?.basePrice)}
            </p>

            {data?.inventoryStatus == "available" && checkProductStock ? (
              <button onClick={() => addProduct(data)}>
                <PiPlusCircleBold className="text-current" size={30} />
              </button>
            ) : (
              <p className="text-sm text-gray-700">نا موجود</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchProductCard;
